import { createSlice } from '@reduxjs/toolkit';
import { defaultTerritory } from '../../common/helpers/projectInitUtil';

const initialState = {
  ...defaultTerritory,
  isConfirmButtonClicked: false,
};

const projectInitSlice = createSlice({
  name: 'projetcInit',
  initialState,
  reducers: {
    updateTerritory: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    confirmButtonClicked: (state, action) => {
      return {
        ...state,
        isConfirmButtonClicked: action.payload,
      };
    },
  },
});

export const getProjectInitConfig = (state) => state.projectInitConfig;
export const getTerritoryCode = (state) =>
  state.projectInitConfig.territoryCode;
export const getIsConfirmButtonClicked = (state) => state.projectInitConfig;
export const { updateTerritory, confirmButtonClicked } =
  projectInitSlice.actions;

export default projectInitSlice.reducer;
